<div class="modal-content">

    <div class="modal-header border-0">
        <h2 class="modal-title mb-0">Hemos recibido exitosamente su denuncia</h2>
        <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.close({estado:false})"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12"><p>Su denuncia fue ingresada con el código: <b>{{data.codigo}}</b></p><p *ngIf="data.anonimo">Como su denuncia es anomina su token de seguimiento sera : <b>{{data.token}}</b></p></div>
            <div class="col-12"><p><b>Recuerda :</b> Guarde este código para hacer el seguimiento de tu denuncia y la podras consultar en <b>Consultar Denuncia</b></p></div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-12 justify-content-center text-center">
                <button (click)="aceptar()" class="btn btn-sm btn-primary mx-1">
                    Aceptar
                </button>
            </div>
        </div>
    </div>

</div>
